import Yup from 'utils/validation';
import { MAX_LIST_TEAMS } from 'modules/candidate-profile/constants';

// Set by the team field once it knows the user's teams; read on validate and submit.
export type TeamFieldState = {
  isRequired: boolean;
  sendsTeams: boolean;
};

export const getUpsertTalentPoolSchema = (teamState: TeamFieldState) =>
  Yup.object({
    name: Yup.string().trim().required('Name is required'),
    teamIds: Yup.array(Yup.string().required())
      .max(MAX_LIST_TEAMS, `Choose no more than ${MAX_LIST_TEAMS} teams`)
      .test(
        'team-required',
        'Make a selection',
        (teamIds) => !teamState.isRequired || Boolean(teamIds?.length)
      ),
    description: Yup.string()
  });

export type UpsertTalentPoolFormData = Yup.InferType<
  ReturnType<typeof getUpsertTalentPoolSchema>
>;
